import { TemplateControlType } from 'src/app/modules/management/store/communication-center';
import { SettingsWrapperControl } from './settings-wrapper-control';
import { IDesignControl } from './design-control';
import { TemplateControlService } from './template-control.service';

const displayControlTemplate = `<table width="100%" class="ql-editor"><tbody></tbody></table>`;
const settingsControlTemplate = ``;

export class TableControl implements IDesignControl {
  id: string;
  parentElement: HTMLElement;
  controlElement: HTMLElement;
  controlTemplate: string = displayControlTemplate;
  settingsTemplate: string = settingsControlTemplate;
  controlType: TemplateControlType.Table;
  editControl: SettingsWrapperControl;
  templateControlService: TemplateControlService;
  document: Document;
  canEdit = true;
  canCopy = true;
  canDelete = true;

  public get childContentElement(): HTMLElement {
    if (this.controlElement.firstElementChild.nodeName === 'TBODY') {
      return this.controlElement.firstElementChild as HTMLElement;
    } else {
      return this.controlElement;
    }
  }

  constructor(document: Document, templateControlService: TemplateControlService) {
    this.document = document;
    this.templateControlService = templateControlService;
  }

  public appendControl(parentElement: HTMLElement): void {
    const container = document.createElement('template');
    container.innerHTML = this.controlTemplate;
    this.controlElement = container.content.firstElementChild as HTMLElement;

    parentElement.appendChild(this.controlElement);
    this.controlElement.style.zIndex = '10';

    this.writeDataAttributeValues();
  }

  public insertSiblingControl(siblingElement: HTMLElement) {
    const container = document.createElement('template');
    container.innerHTML = this.controlTemplate;
    this.controlElement = container.content.firstElementChild as HTMLElement;

    siblingElement.insertAdjacentElement('afterend', this.controlElement);
    this.controlElement.style.zIndex = '10';

    this.writeDataAttributeValues();
  }

  public writeDataAttributeValues() {
    this.controlElement.id = this.id;
    this.controlElement.setAttribute('id', this.id);
    this.controlElement.setAttribute('data-id', this.id);
    this.controlElement.setAttribute('data-control-type', TemplateControlType[this.controlType]);
  }

  public wireUpEvents(): void {}
  public edit(): void {}
  public cancel(): void {}
  public save(): void {}
  public copy(): void {}
  public destroy(): void {
    this.controlElement.remove();
  }
  public dragEnter(event: any): void {}
  public dragLeave(event: any): void {}
  public drop(event): void {}
}
